// extracted by mini-css-extract-plugin
export default {"container":"styles_container__q52Xf","separator":"styles_separator__fv+8E","title":"styles_title__gnVb2","summary":"styles_summary__i6EHv"};